import PropTypes from 'prop-types'
import React, { useCallback, useEffect } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import Input from '@vtex/styleguide/lib/Input'
import Button from '@vtex/styleguide/lib/Button'
import Alert from '@vtex/styleguide/lib/Alert'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import BackHeader from '@/checkout-instore-legacy/components/Commons/BackHeader'
import { useInput } from '@/checkout-instore-legacy/commons/customHooks'
import { FEATURES } from '../constants'

const OrderIdentifier = ({
  clearReturnExchange,
  router,
  setOrderId,
  order,
  orderId: initialOrderId,
  clearError,
  errors,
  orderLoading,
  setOrderLoading,
  intl,
}) => {
  useEffect(() => {
    setOrderLoading(false)
  }, [setOrderLoading])
  useEffect(() => {
    if (order) {
      router.push(`return-exchange/${order.orderId}`)
    }
  }, [order, router])
  const [orderId, changeOrderId] = useInput(initialOrderId || '')
  const orderNotFoundError = errors[FEATURES.ORDER_NOT_FOUND]
  const orderError = errors[FEATURES.ORDER]

  const clearErrors = useCallback(() => {
    orderNotFoundError && clearError(FEATURES.ORDER_NOT_FOUND)
    orderError && clearError(FEATURES.ORDER)
  }, [clearError, orderError, orderNotFoundError])

  const submitOrderId = useCallback(() => {
    setOrderId(orderId.trim())
    clearErrors()
  }, [clearErrors, orderId, setOrderId])

  const handleChangeOrderId = useCallback(
    (e) => {
      changeOrderId(e)
      clearErrors()
    },
    [changeOrderId, clearErrors]
  )

  const handleBack = useCallback(() => {
    clearReturnExchange()
    router.push('/')
  }, [clearReturnExchange, router])

  return (
    <div className="flex flex-auto flex-column items-center bg-muted-5 c-on-base pt8 pb5 overflow-auto">
      <div className="flex flex-column w-50">
        <BackHeader onClick={handleBack} />
        <span className="t-heading-2 pt2">
          <FormattedMessage id="returnExchange.identify.title" />
        </span>
      </div>
      <div className="flex flex-row justify-center bg-base c-on-base pv7 mt7 w-50">
        <div className="flex flex-column mh8 w-100">
          <div>
            <Input
              id="couponCode"
              type="text"
              value={orderId}
              error={orderNotFoundError}
              errorMessage={orderNotFoundError && orderNotFoundError.message}
              label={intl.formatMessage({
                id: 'returnExchange.identify.orderNumber',
              })}
              onChange={handleChangeOrderId}
            />
          </div>
          {orderError && (
            <div className="mt3">
              <Alert
                type={orderError.type}
                onClose={() => clearError(FEATURES.ORDER)}
              >
                <span>{orderError.message}</span>
              </Alert>
            </div>
          )}
          <div className="pt6 flex-auto">
            <Button
              block
              onClick={submitOrderId}
              isLoading={orderLoading}
              disabled={!orderId || orderNotFoundError}
            >
              <FormattedMessage id="returnExchange.identify.searchOrder" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

OrderIdentifier.propTypes = {
  orderLoading: PropTypes.bool,
  order: PropTypes.object,
  setOrderId: PropTypes.func.isRequired,
  errors: PropTypes.object,
  orderId: PropTypes.string,
  router: PropTypes.object,
  clearReturnExchange: PropTypes.func.isRequired,
  clearOrder: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  setOrderLoading: PropTypes.func.isRequired,
  intl: intlShape,
}

export default withRouter(injectIntl(OrderIdentifier))
